export class ReportMessages {
  public signature = 'result_report.signature';
  public certificates = 'report.certificates';
  public informations = 'report.informations';
  public properties = 'report.properties';
  public synthesis = 'report.synthesis';
  public tableContents = 'report.table_contents';
  public timestamp = 'result_report.timestamp';
  public previousTitle = 'report.previous_title';
  public title = 'report.title';
  public newTab = 'report.newTab';
  public asteriskDescription = 'report.asterisk-description';

  constructor() {
  }
}
